import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { SharedSkillService } from '../skill-repository/shared-skill.service';


@Injectable({
  providedIn: 'root'
})

export class SkillRepoEmployeesService {

  title: any;
  private Skillrepofilter = new Subject<number>();
  Skillrepofilter$ = this.Skillrepofilter.asObservable();

  httpOptions = {
    headers: new HttpHeaders(
      {
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token')
      },
    ),
  };
  private apiUrl = environment.apiUrl;
  resorceId: any;
  certificateId: any;
  state: any
  constructor(private sharedskill: SharedSkillService, private http: HttpClient, private _location: Location, private router: Router) { }

  public getEmployeeById(from, size, compId) {
    const url = `${this.apiUrl}Profile/GetAvailableProfilesbyCompetencyId?From=${from}&Size=${size}&competencyId=${compId}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public getCertificateCount(comId,subcompid)
  {
    const url=`${this.apiUrl}Competency/GetPendingAndCompletedCertificatesCount?competencyId=${comId}&subCompetencyId=${subcompid}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public GetSMECount(compId)
  {
    const url=`${this.apiUrl}Profile/GetSMECountByCompetency?competencyId=${compId}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public GetSolutionByVertical(compId)
  {
    const url=`${this.apiUrl}Competency/GetSolutionsByVertical?competencyId=${compId}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public GetResourcesCount(compId)
  {
    const url=`${this.apiUrl}Competency/resource-count?competencyId=${compId}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  public getSubCompetenciesForDropDowns(compId) {
    const url = `${this.apiUrl}Competency/GetSubCompetenciesForDropDowns?competencyId=${compId}`;
    return this.http.get<any>(url, this.httpOptions);
  }
  navigateBack() {
    this._location.back();
  }
  getResourceId() {
    return this.resorceId;
  }

  resourceroute(competencyname, subCompetencyid, subCompetencyName, filter) {
    if (filter == 1) {
      this.state = "TalentPool"
    }
    else if (filter == 2) {
      this.state = "Billable"
    }
    else if (filter == 3) {
      this.state = "NoticePeriod"
    }
    else if (filter == 4) {
      this.state = "AboveAging"
    }
    else if (filter == 5) {
      this.state = "Total"
    }
    this.sharedskill.setSubCompId(subCompetencyid);
    this.title = competencyname.split(' ').join('')

    subCompetencyName = subCompetencyName.replace(/\//g, '');
    subCompetencyName = subCompetencyName.split(' ').join('')

    this.router.resetConfig(this.router.config); /*this line will clear*/

    this.router.navigate([`Home/CMF Portal/${this.title}/${subCompetencyName}/Resources/${this.state}`]);
  }

  certificateroute(competencyname, subCompetencyid, subCompetencyName, filter) {
    if (filter == 1) {
      this.state = "plannedcertifications"
    }
    else if (filter == 2) {
      this.state = "completedcertifications"
    }
    this.sharedskill.setSubCompId(subCompetencyid);
    this.title = competencyname.split(' ').join('')

    subCompetencyName = subCompetencyName.replace(/\//g, '');
    subCompetencyName = subCompetencyName.split(' ').join('');
    this.router.resetConfig(this.router.config); /*this line will clear*/
    this.router.navigate([`Home/CMF Portal/${competencyname}/${subCompetencyName}/Certificates/${this.state}`]);

  }
}
